import Layout from './Layout'
import useFilter from '@components/Items/utils/hooks/useFilter'
import { FC, ReactNode, useState } from 'react'
import { splitActiveIds, QUERY_KEYS } from '@components/Items/utils/functions'
import Checkbox from '@components/Items/components/checkbox'
import { IoIosArrowDown, IoIosArrowForward } from 'react-icons/io'
import _isArray from 'lodash/isArray'
import { usePathname } from 'next/navigation'
import { useRouter } from 'next/router'

const Locations = () => {
  const pathname = usePathname()
  const [_, page] = pathname.split('/')
  const { locationList } = useFilter()

  if (page === 'location') return <></>
  return (
    <Layout label={'LOCATION'}>
      <fieldset>
        <legend className="sr-only">Locations</legend>
        <div className="space-y-1">
          {Object.entries(locationList).map(([stateName, cities]) => (
            <State
              stateName={stateName}
              cities={cities}
              key={`state-${stateName}`}
            />
          ))}
        </div>
      </fieldset>
    </Layout>
  )
}

const State: FC<{ stateName: string; cities: { [p: string]: string } }> = ({
  stateName,
  cities,
}) => {
  const cityList = Object.entries(cities)
  const [isOpen, setIsOpen] = useState(false)
  const { locationQuery, updateQuery } = useFilter()

  const { checked, unchecked } = splitActiveIds(
    (locationQuery
      ? _isArray(locationQuery)
        ? locationQuery
        : [locationQuery]
      : []
    ).map((id) => Number(id)),
    cityList.map(([id]) => Number(id))
  )

  const isIndeterminate = Boolean(checked.length && unchecked.length)
  const isChecked = Boolean(unchecked.length ? false : checked.length)

  const handleChange = () => {
    updateQuery(QUERY_KEYS.LOCATIONS, isChecked ? checked : unchecked, true)
  }

  return (
    <div>
      <Checkbox
        onChange={handleChange}
        checked={isChecked}
        isIndeterminate={isChecked ? false : isIndeterminate}
      >
        <div className={'flex justify-between items-center w-full'}>
          <h3 className={''}> {stateName.toUpperCase()}</h3>
          <button
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              setIsOpen(!isOpen)
            }}
          >
            {isOpen ? <IoIosArrowDown /> : <IoIosArrowForward />}
          </button>
        </div>
      </Checkbox>
      {isOpen ? (
        <div className={'pl-6'}>
          {cityList
            .sort((a, b) => a[1].localeCompare(b[1]))
            .map(([id, cityName]) => (
              <City key={`city-${cityName}-${id}`} id={id} cityName={cityName}>
                {cityName.toUpperCase()}
              </City>
            ))}
        </div>
      ) : (
        <></>
      )}
    </div>
  )
}

const City: FC<{
  id: string | number
  cityName: string
  children: ReactNode
}> = ({ id, cityName }) => {
  const { locationQuery, updateQuery } = useFilter()
  const handleChange = async () => {
    updateQuery(QUERY_KEYS.LOCATIONS, String(id), true)
  }

  const isChecked = locationQuery
    ? _isArray(locationQuery)
      ? locationQuery.includes(String(id))
      : locationQuery === String(id)
    : false

  return (
    <Checkbox onChange={handleChange} checked={isChecked}>
      {cityName.toUpperCase()}
    </Checkbox>
  )
}
export default Locations
